import { EOposNumberOfExams, EVerticalNames, OPOS_NUMBER_OF_EXAMS } from '@constants';
import { IUserInfo } from '@sdk/contracts';
import { Form, FormInstance, Radio, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { FileAttachment } from '../FileAttachment';
import { ExamGroupSelector } from '../Form/ExamGroupSelector';

import { Wrapper, TitleWrapper } from './OposFormContent.styles';

import { AutonomousCommunitySelector } from '@/components/Form';

type OposFormContentProps = {
  form: FormInstance<IUserInfo>;
  isManager: boolean;
};

export const OposFormContent: React.FC<OposFormContentProps> = ({ form, isManager }) => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);
  const data = Form.useWatch([], form) as IUserInfo | undefined;
  const watchedNumberOfExams = Form.useWatch(['numberOfExams'], form);
  const hasExams = watchedNumberOfExams && watchedNumberOfExams !== EOposNumberOfExams.ZERO;

  const handleChangeNumberOfExams = (value: EOposNumberOfExams) => {
    form.setFieldValue(['numberOfExams'], value);
  };

  return (
    <Wrapper>
      {isManager && <TitleWrapper>{t(EVerticalNames.OPOS)}</TitleWrapper>}
      <Form.Item
        name={['autonomousCommunity']}
        label={t('StudentProfileConfigurationTranslations:AUTONOMOUS_COMMUNITY_WORK')}
        initialValue={data?.autonomousCommunity}>
        <AutonomousCommunitySelector allowClear variant="outlined" />
      </Form.Item>
      <Form.Item
        name={['examGroups']}
        label={t('StudentProfileConfigurationTranslations:EXAM_GROUPS')}
        initialValue={data?.examGroups}>
        <ExamGroupSelector
          value={data?.examGroups}
          onChange={(value: string[] | string) =>
            form.setFieldsValue({ examGroups: Array.isArray(value) ? value : [value] })
          }
        />
      </Form.Item>
      <Form.Item
        name={['hasMasterDegree']}
        label={t('StudentProfileConfigurationTranslations:HAS_MASTER_DEGREE')}
        initialValue={data?.hasMasterDegree}>
        <Radio.Group onChange={e => form.setFieldValue(['hasMasterDegree'], e.target.value)}>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name={['numberOfExams']}
        label={t('StudentProfileConfigurationTranslations:NUMBER_OF_EXAMS')}
        initialValue={data?.numberOfExams}>
        <Select
          placeholder={t('StudentProfileConfigurationTranslations:SELECT_NUMBER_OF_EXAMS')}
          onChange={handleChangeNumberOfExams}
          options={OPOS_NUMBER_OF_EXAMS.map(exam => ({
            value: exam,
            label: t(`StudentProfileConfigurationTranslations:${exam}`)
          }))}
        />
      </Form.Item>
      {hasExams && (
        <Form.Item
          name={['examsCertificates']}
          label={t('StudentProfileConfigurationTranslations:EXAMS_CERTIFICATES')}>
          <FileAttachment />
        </Form.Item>
      )}
    </Wrapper>
  );
};
